module.exports = __webpack_public_path__ + "img/pr-16.a4590d8b.png";